import React, { useEffect, useState } from "react";
import api, { formatApiError } from "../../lib/api";
import { Window, Dialog, ConfirmDialog, EmptyState, Loading } from "../../components/VB";
import RupiahInput from "../../components/RupiahInput";
import { toast } from "sonner";
import { Plus, Trash2 } from "lucide-react";

export default function Tunjangan() {
  const [items, setItems] = useState([]);
  const [emps, setEmps] = useState([]);
  const [loading, setLoading] = useState(true);
  const [open, setOpen] = useState(false);
  const [form, setForm] = useState({ nama: "", jenis: "Transport", nominal: 0, employee_id: "", periode: "Bulanan", status_aktif: true });
  const [del, setDel] = useState(null);

  const load = async () => {
    setLoading(true);
    try {
      const [t, e] = await Promise.all([api.get("/tunjangan"), api.get("/employees")]);
      setItems(t.data); setEmps(e.data);
    } catch (err) { toast.error(formatApiError(err.response?.data?.detail)); }
    setLoading(false);
  };
  useEffect(() => { load(); }, []);

  const submit = async (e) => {
    e.preventDefault();
    try {
      await api.post("/tunjangan", { ...form, nominal: parseFloat(form.nominal) });
      toast.success("Tunjangan tersimpan");
      setOpen(false); load();
    } catch (err) { toast.error(formatApiError(err.response?.data?.detail)); }
  };
  const doDelete = async () => {
    try { await api.delete(`/tunjangan/${del.id}`); toast.success("Dihapus"); setDel(null); load(); }
    catch (err) { toast.error(formatApiError(err.response?.data?.detail)); }
  };
  const empName = (id) => emps.find((e) => e.id === id)?.nama_lengkap || "-";

  return (
    <Window
      title="Management Tunjangan"
      actions={<button className="vb-btn" onClick={() => setOpen(true)} data-testid="add-tunjangan"><Plus className="w-3 h-3 inline mr-1" />Tambah</button>}
    >
      {loading ? <Loading /> : items.length === 0 ? <EmptyState /> : (
        <table className="vb-table">
          <thead><tr><th>Nama</th><th>Jenis</th><th>Karyawan</th><th>Nominal</th><th>Periode</th><th>Status</th><th>Aksi</th></tr></thead>
          <tbody>
            {items.map((it) => (
              <tr key={it.id}>
                <td>{it.nama}</td><td>{it.jenis}</td><td>{empName(it.employee_id)}</td>
                <td>Rp {it.nominal?.toLocaleString("id-ID")}</td><td>{it.periode}</td>
                <td>{it.status_aktif ? "Aktif" : "Nonaktif"}</td>
                <td><button className="vb-btn-danger" style={{ padding: "2px 6px" }} onClick={() => setDel(it)} data-testid={`tj-del-${it.id}`}><Trash2 className="w-3 h-3" /></button></td>
              </tr>
            ))}
          </tbody>
        </table>
      )}

      <Dialog open={open} onClose={() => setOpen(false)} title="Tambah Tunjangan"
        footer={<><button className="vb-btn" onClick={() => setOpen(false)}>Batal</button><button className="vb-btn-primary" onClick={submit} data-testid="tj-save">Simpan</button></>}>
        <form onSubmit={submit}>
          <div className="vb-form-row"><label className="vb-label">Nama Tunjangan*</label>
            <input className="vb-input" value={form.nama} onChange={(e) => setForm({ ...form, nama: e.target.value })} required data-testid="tj-nama" /></div>
          <div className="vb-form-row"><label className="vb-label">Jenis*</label>
            <select className="vb-select" value={form.jenis} onChange={(e) => setForm({ ...form, jenis: e.target.value })} data-testid="tj-jenis">
              <option>Transport</option><option>Makan</option><option>Jabatan</option><option>Lembur</option><option>Bonus</option><option>Lainnya</option>
            </select></div>
          <div className="vb-form-row"><label className="vb-label">Karyawan*</label>
            <select className="vb-select" value={form.employee_id} onChange={(e) => setForm({ ...form, employee_id: e.target.value })} required data-testid="tj-employee">
              <option value="">- pilih -</option>
              {emps.map((e) => <option key={e.id} value={e.id}>{e.nama_lengkap}</option>)}
            </select></div>
          <div className="vb-form-row"><label className="vb-label">Nominal*</label>
            <RupiahInput value={form.nominal} onChange={(v) => setForm({ ...form, nominal: v })} required testId="tj-nominal" /></div>
          <div className="vb-form-row"><label className="vb-label">Periode*</label>
            <select className="vb-select" value={form.periode} onChange={(e) => setForm({ ...form, periode: e.target.value })} data-testid="tj-periode">
              <option>Harian</option><option>Mingguan</option><option>Bulanan</option>
            </select></div>
          <label style={{ fontSize: 13 }}><input type="checkbox" checked={form.status_aktif} onChange={(e) => setForm({ ...form, status_aktif: e.target.checked })} /> Aktif</label>
        </form>
      </Dialog>

      <ConfirmDialog open={!!del} onClose={() => setDel(null)} onConfirm={doDelete} message="Yakin hapus tunjangan ini?" />
    </Window>
  );
}
